import { render, staticRenderFns } from "./quick-update.vue?vue&type=template&id=1ef41bfe&scoped=true&"
import script from "./quick-update.vue?vue&type=script&lang=js&"
export * from "./quick-update.vue?vue&type=script&lang=js&"
import style0 from "./quick-update.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./quick-update.vue?vue&type=style&index=1&id=1ef41bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef41bfe",
  null
  
)

export default component.exports